import { useTranslation } from 'react-i18next';
import type { UseTranslationResponse } from 'react-i18next';

export const keyPrefix = 'permission_tag_department_list_info';
export const usePermissionTagDepartmentListInfoTranslation = (): UseTranslationResponse<'widgets', typeof keyPrefix> => {
  return useTranslation('widgets', { keyPrefix });
};

export const ruRu = ({
  [keyPrefix]: {
    title: 'Используется',
    subtitle: 'Подразделения ({{count}})',
  },
}) as Record<string, unknown>;

export const en = ({
  [keyPrefix]: {
    title: 'Used at',
    subtitle: 'Departments ({{count}})',
  },
}) as Record<string, unknown>;

export const esEs = ({
  [keyPrefix]: {
    title: 'Usado',
    subtitle: 'Departamentos ({{count}})',
  },
}) as Record<string, unknown>;

export const ptBr = ({
  [keyPrefix]: {
    title: 'Usado',
    subtitle: 'Departamentos ({{count}})',
  },
}) as Record<string, unknown>;
